import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
    } else {
      navigate('/admin/dashboard');
    }

    setLoading(false);
  };

  const INPUT_CLASS =
    'w-full bg-white/10 border border-white/20 text-white font-poppins text-sm rounded-lg px-4 py-3 placeholder-white/40 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors duration-200';

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-6">
      <div className="w-full max-w-sm flex flex-col items-center gap-8">

        {/* Logo */}
        <img
          src="/Assets/Logos/TNL-Horizontal-White&Grey.png"
          alt="Trivia Nights Live"
          className="h-14 w-auto"
        />

        {/* Card */}
        <div className="w-full bg-white/5 border border-white/10 rounded-2xl p-8 flex flex-col gap-6">
          <h1 className="font-poppins font-bold text-white text-xl text-center tracking-wide">
            Admin Login
          </h1>

          {error && (
            <p className="font-poppins text-xs text-red-400 text-center bg-red-400/10 border border-red-400/20 rounded-lg px-4 py-2">
              {error}
            </p>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
                className={INPUT_CLASS}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-poppins text-white text-xs font-semibold tracking-widest uppercase">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className={INPUT_CLASS}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="mt-2 w-full bg-gold text-dark font-poppins font-bold text-sm tracking-widest rounded-lg py-3 hover:bg-yellow-400 active:scale-95 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'SIGNING IN...' : 'SIGN IN'}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default AdminLogin;
